/** Level 2 timed mock forms — same 4-mock product pattern as L1. */

export const L2_MOCK_FORM_COUNT = 4;
/** One complimentary L2 Mock 1 per account (separate from L1 free mock). */
export const L2_FREE_MOCK_FORM = 1;

export const L2_MOCK_FORMS = Array.from({ length: L2_MOCK_FORM_COUNT }, (_, i) => {
  const id = i + 1;
  return {
    id,
    slug: `session-${id}`,
    label: `Mock ${id}`,
    shortLabel: `Session ${id}`,
    href: `/quiz/l2/session-${id}`,
    free: id === L2_FREE_MOCK_FORM,
    blurb:
      id === 1
        ? 'Full curriculum item-set mock · all ten Level 2 topics · on-screen BA II Plus · free once'
        : 'Distinct item sets from the other forms · same topic weights · timed CBT',
  };
});

export function parseL2MockFormId(slug = '') {
  const s = String(slug || '').toLowerCase();
  if (s === 'session' || s === 'all' || s === 'mock') return null;
  // Bounded by L2_MOCK_FORM_COUNT (CFA-63) — not a literal range, not any number.
  const m = /^session-(\d+)$/.exec(s);
  if (!m || Number(m[1]) < 1 || Number(m[1]) > L2_MOCK_FORM_COUNT) return null;
  return Number(m[1]);
}

export function l2MockFormById(id) {
  return L2_MOCK_FORMS.find((f) => f.id === Number(id)) || null;
}
